// R34 fix — singleton QueryClient exported here so it's importable from
// api.ts (R21 401 retry-after-refresh path) and the sidebar Sign Out
// handler (R33 cross-account leak fix). Without a singleton, references
// to `queryClient` elsewhere resolve to undefined.

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
